<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Set sub district on app</h1>
    <v-data-table
      :headers="headers"
      :loading="loading_message"
      :items="province_th_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center" width="10%">{{ province_th_list.indexOf(props.item)+1 }}</td>
        <td class="text-xs-center" width="40%">{{ props.item.sub_district_name_th }}</td>
        <td class="text-xs-center" width="30%" v-if="isEditIndex != props.index">
          {{
          props.item.sub_district_name_en }}
        </td>
        <td class="text-xs-center" width="10%" v-else>
          <v-text-field
            :loading="isEditing"
            @keyup.enter="updateSubdistrictEN(props.item)"
            v-model="props.item.sub_district_name_en"
            placeholder="Enter sub district en"
            solo
            hide-details
            class="my-2"
          ></v-text-field>
        </td>
        <td class="text-xs-center" width="10%" v-if="isEditIndex != props.index">
          <v-btn icon small @click="isEditIndex = props.index" :disabled="isEditIndex != -1">
            <v-icon small>edit</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center" width="10%" v-if="isEditIndex == props.index">
          <v-btn icon small @click="updateSubdistrictEN(props.item)">
            <v-icon small>save</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <div class="text-xs-center" v-if="loading_message== false">No data available ..</div>
        <div class="text-xs-center" v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>Loading data ...
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

import { mapState } from "vuex";
export default {
  data() {
    return {
      isEditing: false,
      isEditIndex: -1,
      loading_message: false,
      pagination: { rowsPerPage: 10 },
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false
        },
        {
          text: "Name TH",
          align: "center",
          sortable: false
        },
        {
          text: "Name EN",
          align: "center",
          sortable: false,
          value: "name_en"
        },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapState({
      provinceData: state => state.fetchProvinceBack.provinceData,
      province_th_list: state => state.fetchFoodSetAppBack.province_th_list
    })
  },
  methods: {
    toEdit(index) {
      if (this.isEditIndex != -1) {
        this.updateSubdistrictEN(item);
      }
      this.isEditIndex = index;
    },
    async updateSubdistrictEN(item) {
      let check = false;
      this.isEditing = true;
      check = await this.$store.dispatch(
        "fetchFoodSetAppBack/updateENSubdistrict",
        item
      );
      this.isEditing = false;
      if (check == true) {
        this.isEditIndex = -1;
      }
    },
    splitProvince(province) {
      let province_set = "";
      let province_split = province.split(" ");
      for (let val of province_split) {
        province_set += val;
      }
      return province_set;
    },
    findProvince(province) {
      let result = null;
      for (let val of this.provinceData) {
        if (
          this.splitProvince(val.province_name_en.toLowerCase()) == province
        ) {
          result = val.province_id;
        }
      }
      return result;
    }
  },
  async created() {
    this.loading_message = true;
    await this.$store.dispatch(
      "fetchFoodSetAppBack/getSubdistrictTH",
      this.findProvince(this.$route.params.province)
    );
    this.loading_message = false;
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "App setting",
        disabled: true
      },
      {
        text: "Set sub district",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
